/* eslint-disable */
export default {
  unknown: 'Desconhecido',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
